// extracted by mini-css-extract-plugin
module.exports = {"lblCAContainer":"LabelsCA-module__lblCAContainer","hasBrdr":"LabelsCA-module__hasBrdr"};